import * as Yup from "yup";
import { FormikProvider, useFormik } from "formik";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";
import InputFormik from "../../../../common/components/form/InputFormik";
import ButtonWithLoader from "../../../../common/components/ui/loading/ButtonLoading";
import { createSubProduct } from "../../../../common/services/product.api";
import { emptyProduct, IProduct } from "../../../../types/product.types";
import { useParams } from "react-router-dom";

const validationSchema = Yup.object().shape({
  name: Yup.string().required('Nome do produto obrigatório'),
  maximumApplication: Yup.number().required('Máxima aplicação é obrigatória').test(
    "greater-than-zero",
    "Tem que ser maior que zero",
    value => value > 0
  ),
  durability: Yup.number().required('Quantidade de meses é obrigatória').test(
    "greater-than-zero",
    "Tem que ser maior que zero",
    value => value > 0
  )
});

type Props = {
  onSubmit: () => void
}


export default function FormCreateSubProduct(props: Props) {
  const { notifySuccess, notifyError } = useToastContext();
  const params = useParams();

  const formik = useFormik({
    initialValues: emptyProduct(),
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (data: IProduct) => {
      const result = await createSubProduct({ ...data, productId: params.productId as string });

      if (!result.ok) {
        notifyError(result.message as string);
        return;
      }
      notifySuccess("Criado com sucesso");
      props.onSubmit();
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <FormikProvider value={formik}>
        <div className="grid grid-cols-2 gap-2">
          <InputFormik
            label="Descrição:"
            name="name"
            className="col-span-3"
            required={true}
          />
          <InputFormik
            label="Aplicação Máxima:"
            name="maximumApplication"
            className="col-span-3"
            required={true}
          />
          <InputFormik
            label="Dias de Durabilidade:"
            name="durability"
            className="col-span-3"
            required={true}
          />
        </div>
        <div className="flex justify-end col-span-5">
          <ButtonWithLoader disabled={Object.values(formik.errors).length ? true : false} isLoading={formik.isSubmitting} onClick={formik.handleSubmit}>
            Enviar
          </ButtonWithLoader>
        </div>
      </FormikProvider>
    </form>
  );
}